export default __webpack_public_path__ + "static/logo500-d8279180085a6b66d50bea84def2b7b6.png";